@if(loading) {

  <div class="d-flex align-items-center justify-content-center" style="min-height: 100vh;">
    <div class="text-center">
      <div
        class="spinner-border text-primary"
        style="width: 5rem; height: 5rem;"
        role="status"
        aria-label="Cargando examen">
      </div>
      <p class="mt-3 text-secondary fw-medium mb-0">Cargando examen...</p>
    </div>
  </div>

} @else if(state === 'signing') {

  <!-- =========================================================
    Signing view — touch device, exam finished, waiting for signature
  ========================================================= -->
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">

        <div class="card exam-result__card border-0 shadow-sm">
          <div class="card-body p-4 p-md-5">

            <div class="text-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" fill="currentColor" class="text-secondary mb-3" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
              </svg>
              <h5 class="fw-bold mb-1">Firma digital</h5>
              <p class="text-secondary small mb-0">
                Tu examen fue enviado. Dibuja tu firma para ver tu resultado.
              </p>
            </div>

            <app-signature-capture
              (confirmed)="onSignatureConfirmed($event)">
            </app-signature-capture>

            @if(isSigning) {
              <div class="text-center mt-3">
                <div class="spinner-border spinner-border-sm text-secondary" role="status" aria-label="Guardando firma"></div>
                <span class="ms-2 text-secondary small">Guardando firma...</span>
              </div>
            }

          </div>
        </div>

      </div>
    </div>
  </div>

} @else if(state === 'needsMobileDevice') {

  <!-- =========================================================
    NeedsMobileDevice view — desktop, exam finished, must sign from tablet/phone
  ========================================================= -->
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">

        <div class="card exam-result__card border-0 shadow-sm text-center">
          <div class="card-body p-5">

            <div class="text-secondary mb-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"/>
                <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
              </svg>
            </div>

            <h5 class="fw-bold mb-3">Tu examen fue enviado correctamente</h5>
            <p class="text-secondary mb-4">
              Para ver tu resultado debes abrir el folio
              <strong>{{ idOrFolio }}</strong>
              desde una tableta o teléfono y colocar tu firma digital.
            </p>

            <div class="d-grid">
              <a class="btn exam-result__back-btn" routerLink="/">
                Regresar al inicio
              </a>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

} @else if(state === 'result') {

  <!-- =========================================================
    Result view — shown when exam is already finished or just submitted
  ========================================================= -->
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">

        @if(displayResult) {

          <div class="card exam-result__card border-0 shadow-sm text-center">
            <div class="card-body p-5">

              @if(displayResult.passed) {
                <div class="text-success mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                  </svg>
                </div>
                <h2 class="text-success fw-bold mb-1">APROBADO</h2>
              } @else {
                <div class="text-danger mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </div>
                <h2 class="text-danger fw-bold mb-1">REPROBADO</h2>
              }

              @if(displayResult.examName) {
                <p class="text-secondary mt-2 mb-0">{{ displayResult.examName }}</p>
              }

              <div class="display-3 fw-bold mt-3 mb-1 exam-result__score">
                {{ displayResult.score | number: '1.0-1' }}
              </div>
              <p class="text-secondary mb-4">Puntaje obtenido</p>

              <hr>
              <div class="row mt-4">
                <div class="col-6 text-start mb-3">
                  <small class="text-secondary d-block">Respuestas correctas</small>
                  <span class="fw-bold fs-5">
                    {{ displayResult.correctCount }} / {{ displayResult.totalCount }}
                  </span>
                </div>
                <div class="col-6 text-start mb-3">
                  <small class="text-secondary d-block">Puntaje mínimo para aprobar</small>
                  <span class="fw-bold fs-5">{{ displayResult.passingScore }}%</span>
                </div>
              </div>

              <div class="d-grid mt-3">
                <a class="btn exam-result__back-btn" routerLink="/">
                  Regresar al inicio
                </a>
              </div>

            </div>
          </div>

        } @else {

          <div class="text-center py-5">
            <p class="text-secondary mb-4">No hay resultados disponibles.</p>
            <a class="btn exam-result__back-btn" routerLink="/">
              Regresar al inicio
            </a>
          </div>

        }

      </div>
    </div>
  </div>

} @else {

  <!-- =========================================================
    Sticky header — exam name + progress bar
  ========================================================= -->
  <header class="exam-header">
    <div class="container">
      <div class="d-flex align-items-center gap-3 py-3">

        @if (examName) {
          <span class="exam-header__name fw-semibold text-truncate">{{ examName }}</span>
          <span class="exam-header__sep text-secondary-subtle d-none d-sm-inline">|</span>
        }

        <div class="d-flex align-items-center gap-2 flex-grow-1 min-w-0">
          <div
            class="progress flex-grow-1 exam-header__track"
            role="progressbar"
            [attr.aria-valuenow]="progressPercent"
            aria-valuemin="0"
            aria-valuemax="100"
            [attr.aria-label]="answeredCount + ' de ' + questions.length + ' preguntas respondidas'">
            <div class="progress-bar exam-header__bar" [style.width.%]="progressPercent"></div>
          </div>
          <small class="text-secondary fw-medium text-nowrap">
            {{ answeredCount }} / {{ questions.length }}
          </small>
        </div>

      </div>
    </div>
  </header>

  <!-- =========================================================
    Questions — all rendered in one scroll
  ========================================================= -->
  <main class="container exam-main pt-4">

    <!-- Material del examen (arriba, antes de las tarjetas) -->
    @if (examFiles.length) {
      <section class="exam-material mb-4" aria-label="Material de apoyo del examen">
        <p class="exam-material__title">Material de apoyo</p>
        <div class="exam-material__grid">
          @for (file of examFiles; track file.idFile) {
            @if (file.fileType === 'image') {
              <div
                class="exam-material__img-link"
                role="button"
                tabindex="0"
                aria-label="Ver imagen de material de apoyo en tamaño completo"
                (click)="openImageModal(file.urlFile)"
                (keydown.enter)="openImageModal(file.urlFile)"
                (keydown.space)="$event.preventDefault(); openImageModal(file.urlFile)">
                <img
                  class="exam-material__img"
                  [src]="file.urlFile"
                  alt="Material de apoyo del examen"
                  loading="lazy">
              </div>
            } @else {
              <a
                class="exam-material__pdf"
                [href]="file.urlFile"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Abrir documento PDF en nueva pestaña">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                  <line x1="10" y1="9" x2="8" y2="9"/>
                </svg>
                Ver documento PDF
              </a>
            }
          }
        </div>
      </section>
    }

    @for (question of questions; track question.idQuestion; let i = $index) {
      <article class="card exam-card border-0 shadow-sm mb-4">
        <div class="card-body p-4">

          <!-- Badge + Statement -->
          <div class="d-flex align-items-start gap-3 mb-4">
            <span class="badge exam-card__badge rounded-pill flex-shrink-0">{{ i + 1 }}</span>
            <p class="mb-0 fw-semibold exam-card__statement">{{ question.statement }}</p>
          </div>

          <!-- Material de la pregunta (debajo del enunciado, antes de opciones) -->
          @if (question.files.length) {
            <div class="exam-material exam-material--compact mb-3" aria-label="Material de apoyo de la pregunta">
              <div class="exam-material__grid">
                @for (file of question.files; track file.idFile) {
                  @if (file.fileType === 'image') {
                    <div
                      class="exam-material__img-link"
                      role="button"
                      tabindex="0"
                      aria-label="Ver imagen de material de apoyo en tamaño completo"
                      (click)="openImageModal(file.urlFile)"
                      (keydown.enter)="openImageModal(file.urlFile)"
                      (keydown.space)="$event.preventDefault(); openImageModal(file.urlFile)">
                      <img
                        class="exam-material__img"
                        [src]="file.urlFile"
                        alt="Material de apoyo de la pregunta"
                        loading="lazy">
                    </div>
                  } @else {
                    <a
                      class="exam-material__pdf"
                      [href]="file.urlFile"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Abrir documento PDF en nueva pestaña">
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                        <polyline points="14 2 14 8 20 8"/>
                        <line x1="16" y1="13" x2="8" y2="13"/>
                        <line x1="16" y1="17" x2="8" y2="17"/>
                        <line x1="10" y1="9" x2="8" y2="9"/>
                      </svg>
                      Ver documento PDF
                    </a>
                  }
                }
              </div>
            </div>
          }

          <!-- Hint for multiple choice -->
          @if (question.questionType === 'multiple_choice') {
            <p class="small text-secondary mb-3 ps-1">
              Selecciona todas las opciones que apliquen.
            </p>
          }

          <!-- ---- single_choice ---- -->
          @if (question.questionType === 'single_choice') {
            @for (option of question.options; track option.idQuestionOption) {
              <div
                class="exam-option"
                [class.exam-option--selected]="isSingleSelected(question, option.idQuestionOption)"
                (click)="onSingleSelect(question, option.idQuestionOption)"
                role="radio"
                [attr.aria-checked]="isSingleSelected(question, option.idQuestionOption)"
                tabindex="0"
                (keydown.enter)="onSingleSelect(question, option.idQuestionOption)"
                (keydown.space)="$event.preventDefault(); onSingleSelect(question, option.idQuestionOption)">
                <span class="exam-option__dot exam-option__dot--radio" aria-hidden="true"></span>
                <span class="exam-option__label">{{ option.text }}</span>
              </div>
            }
          }

          <!-- ---- multiple_choice ---- -->
          @if (question.questionType === 'multiple_choice') {
            @for (option of question.options; track option.idQuestionOption) {
              <div
                class="exam-option"
                [class.exam-option--selected]="isMultipleSelected(question, option.idQuestionOption)"
                (click)="onMultipleToggle(question, option.idQuestionOption)"
                role="checkbox"
                [attr.aria-checked]="isMultipleSelected(question, option.idQuestionOption)"
                tabindex="0"
                (keydown.enter)="$event.preventDefault(); onMultipleToggle(question, option.idQuestionOption)"
                (keydown.space)="$event.preventDefault(); onMultipleToggle(question, option.idQuestionOption)">
                <span class="exam-option__dot exam-option__dot--checkbox" aria-hidden="true"></span>
                <span class="exam-option__label">{{ option.text }}</span>
              </div>
            }
          }

          <!-- ---- numeric ---- -->
          @if (question.questionType === 'numeric') {
            <div class="exam-numeric">
              <label [for]="'num-' + question.idQuestion" class="form-label small fw-medium text-secondary mb-2">
                Valor numérico
              </label>
              <input
                type="number"
                class="form-control exam-numeric__input"
                [id]="'num-' + question.idQuestion"
                [ngModel]="getNumericValue(question)"
                (ngModelChange)="onNumericChange(question, $event)"
                placeholder="0"
                step="any">
            </div>
          }

        </div>
      </article>
    }

  </main>

  <!-- =========================================================
    Sticky bottom bar — finalize action
  ========================================================= -->
  <footer class="exam-footer">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between py-3">
        <span class="text-secondary small d-none d-sm-inline">
          {{ answeredCount }} de {{ questions.length }} preguntas respondidas
        </span>
        <div class="d-flex align-items-center gap-3 ms-auto">
          @if (answeredCount < questions.length) {
            <span class="exam-footer__warning small">
              Faltan {{ questions.length - answeredCount }} preguntas por responder
            </span>
          }
          <button
            class="btn exam-footer__btn"
            [disabled]="answeredCount < questions.length || isSubmitting"
            (click)="openConfirmModal()"
            aria-label="Finalizar examen">
            @if (isSubmitting) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Enviando...
            } @else {
              Finalizar examen
            }
          </button>
        </div>
      </div>
    </div>
  </footer>

  <!-- =========================================================
    Image preview modal (lightbox)
  ========================================================= -->
  <ng-template #imagePreviewModal let-modal>
    <div class="img-preview">
      <button
        type="button"
        class="img-preview__close"
        (click)="modal.dismiss()"
        aria-label="Cerrar imagen">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
      <div class="img-preview__canvas">
        <img
          class="img-preview__img"
          [src]="previewImageUrl"
          alt="Vista previa de imagen de material de apoyo">
      </div>
    </div>
  </ng-template>

  <!-- =========================================================
    Confirm modal
  ========================================================= -->
  <ng-template #confirmModal let-modal>
    <div class="modal-header border-0 pb-1">
      <h5 class="modal-title fw-bold">Finalizar examen</h5>
      <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Cerrar"></button>
    </div>
    <div class="modal-body py-3">
      <p class="mb-1 text-dark">¿Deseas enviar el examen?</p>
      <p class="text-secondary small mb-0">
        Has respondido <strong>{{ answeredCount }}</strong> de <strong>{{ questions.length }}</strong>
        preguntas. Una vez enviado no podrás modificar tus respuestas.
      </p>
    </div>
    <div class="modal-footer border-0 pt-1">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
      <button
        type="button"
        class="btn exam-footer__btn"
        (click)="modal.close(); onFinalize()">
        Confirmar y enviar
      </button>
    </div>
  </ng-template>

}
